import React, { useEffect, useState } from "react";
import "./BottleCollInp.css";
import PlasticBottle from "./plascoll.jpg";
import { useNavigate } from "react-router";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "./firebase-config";

function BottleCollInp(props) {
  const navigate = useNavigate();
  const [bottles, setBottles] = useState(0);
  const handleSubmit = async () => {
    // navigate('/bottlecoll', {state:{bt:bottles}})
    let pointsl = bottles * 10;
    await updateDoc(doc(db, "Users", props.Ref), {
      cpoints: props.Points + pointsl,
      lpoints: props.lpoints + pointsl,
    });
    navigate('/bottlecoll')
  };
  return (
    <div>
      <div>
        <img src={PlasticBottle} className="bottle-img" />
        <button
          className="btn-plus"
          onClick={() => {
            if (bottles > 0) {
              setBottles(bottles - 1);
            } else {
              console.log("bottles is 0");
            }
          }}
        >
          -
        </button>
        <button
          className="btn-minus"
          onClick={() => {
            setBottles(bottles + 1);
          }}
        >
          Add bottle
        </button>
        <h1 className="num">{bottles}</h1>
        <button className="btn-sub" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}

export default BottleCollInp;
